const trimTrailingSlash = (value: string) => value.replace(/\/+$/, "");
const trimSlashes = (value: string) => value.replace(/^\/+|\/+$/g, "");

export const BUILD_PATH = trimSlashes(process.env.REACT_APP_BUILD_PATH ?? "");
export const BUILD_PATH_COUNT = BUILD_PATH.length;
export const DEFAULT_OPTION = "";
export const DEFAULT_PROPERTY_STATE = "TN";
export const READY_FOR_MULCH_DESCRIPTION_STORAGE_KEY =
  "ReadyForMulch_Description";
export const STATE_VALIDATION_STORAGE_KEY = "StateValidation";
export const PRIORITY_STORAGE_KEY = "Priority_Description";
export const ALLOWED_MAP_FILE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
  "image/gif",
];
export const MAX_MAP_FILE_SIZE_BYTES = 5 * 1024 * 1024;

export const US_STATE_OPTIONS = [
  { id: "AL", name: "Alabama" },
  { id: "AK", name: "Alaska" },
  { id: "AZ", name: "Arizona" },
  { id: "AR", name: "Arkansas" },
  { id: "CA", name: "California" },
  { id: "CO", name: "Colorado" },
  { id: "CT", name: "Connecticut" },
  { id: "DE", name: "Delaware" },
  { id: "FL", name: "Florida" },
  { id: "GA", name: "Georgia" },
  { id: "HI", name: "Hawaii" },
  { id: "ID", name: "Idaho" },
  { id: "IL", name: "Illinois" },
  { id: "IN", name: "Indiana" },
  { id: "IA", name: "Iowa" },
  { id: "KS", name: "Kansas" },
  { id: "KY", name: "Kentucky" },
  { id: "LA", name: "Louisiana" },
  { id: "ME", name: "Maine" },
  { id: "MD", name: "Maryland" },
  { id: "MA", name: "Massachusetts" },
  { id: "MI", name: "Michigan" },
  { id: "MN", name: "Minnesota" },
  { id: "MS", name: "Mississippi" },
  { id: "MO", name: "Missouri" },
  { id: "MT", name: "Montana" },
  { id: "NE", name: "Nebraska" },
  { id: "NV", name: "Nevada" },
  { id: "NH", name: "New Hampshire" },
  { id: "NJ", name: "New Jersey" },
  { id: "NM", name: "New Mexico" },
  { id: "NY", name: "New York" },
  { id: "NC", name: "North Carolina" },
  { id: "ND", name: "North Dakota" },
  { id: "OH", name: "Ohio" },
  { id: "OK", name: "Oklahoma" },
  { id: "OR", name: "Oregon" },
  { id: "PA", name: "Pennsylvania" },
  { id: "RI", name: "Rhode Island" },
  { id: "SC", name: "South Carolina" },
  { id: "SD", name: "South Dakota" },
  { id: "TN", name: "Tennessee" },
  { id: "TX", name: "Texas" },
  { id: "UT", name: "Utah" },
  { id: "VT", name: "Vermont" },
  { id: "VA", name: "Virginia" },
  { id: "WA", name: "Washington" },
  { id: "WV", name: "West Virginia" },
  { id: "WI", name: "Wisconsin" },
  { id: "WY", name: "Wyoming" },
];


console.log("BASE_URL:", process.env.REACT_APP_BASE_URL);
export const BASE_URL = `${trimTrailingSlash(process.env.REACT_APP_BASE_URL ?? "")}/`;

export const UPFLOW_URL = `${BASE_URL}benchmark_api`;

export const URL = `${BASE_URL}benchmark_api/index.php`;

export const SERVER_URL = BUILD_PATH
  ? `${window.location.origin}/${BUILD_PATH}/`
  : `${window.location.origin}/`;

export const DATE_FORMAT = "DD-MMM-YYYY";
export const DATE_FORMAT_UPDATED = "MM/DD/YYYY";


export const APP_BASE_URL_METHOD = "POST";
export const APP_FOOTER = `Copyright © ${new Date().getFullYear()} KeeneSystems.com`;
export const COMPANY_LOGO_ALT = "Benchmarkcos";

export const BENCHMARK_CONTACT = "BENCHMARK_CONTACT";
export const BENCHMARK_ORGANISATION = "BENCHMARK_ORGANISATION";
export const BENCHMARK_CONTACTLIST = "BENCHMARK_CONTACTLIST";
export const BENCHMARK_INSTALLATIONLIST = "BENCHMARK_INSTALLATIONLIST";
export const BENCHMARK_INVOICING_LIST = "BENCHMARK_INVOICING_LIST";
export const BENCHMARK_INVOICING_PRINT = "BENCHMARK_INVOICING_PRINT";
export const BENCHMARK_PROPERTIES = "BENCHMARK_PROPERTIES";
export const BENCHMARK_QUOTES = "BENCHMARK_QUOTES";
export const BENCHMARK_SCHEDULING = "BENCHMARK_SCHEDULING";
export const BENCHMARK_SCHEDULINGCOMPLETED = "BENCHMARK_SCHEDULINGCOMPLETED";
export const BENCHMARK_SCHEDULINGPRODUCTS = "BENCHMARK_SCHEDULINGPRODUCTS";

export const BENCHMARK_SINGLECONTACT = "BENCHMARK_SINGLECONTACT";
export const BENCHMARK_SINGLEAPPROVALQUOTE = "BENCHMARK_SINGLEAPPROVALQUOTE";
export const BENCHMARK_SINGLEREQUESTEDCHANGE =
  "BENCHMARK_SINGLEREQUESTEDCHANGE";
export const BENCHMARK_SINGLEMAP = "BENCHMARK_SINGLEMAP";

export const LOGIN_URL = "/login";

export const LOGIN_API = "LOGIN_API";
export const RESET_API = "RESET_API";
export const RESET_API_TOKEN = "RESET_API_TOKEN";

export const FORGOT_PASSWORD_API = "FORGOT_PASSWORD_API";
export const CHANGE_PASSWORD_API = "CHANGE_PASSWORD_API";

export const dateFormat = "dd-MM-yyyy";

export const RELOAD_TRUCK = `${BASE_URL}benchmark_api/media/videos/ReloadTruck.mp4`;

export const Gallery1 = `${BASE_URL}benchmark_api/media/images/gallery1.png`;
export const Gallery2 = `${BASE_URL}benchmark_api/media/images/gallery2.jpg`; 
export const Gallery3 = `${BASE_URL}benchmark_api/media/images/gallery3.jpg`;
export const clientConnectionStandards = `${BASE_URL}benchmark_api/media/images/clientConnectionStandards.png`;
